<!-- Pagination Component -->
<nav class="pg-root" aria-label="Pagination">

  <!-- Left: page size selector + info -->
  <div class="pg-left">
    <!-- Rows per page selector -->
    <div class="pg-size-wrap">
      <label class="pg-size-label" [for]="sizeId">Rows</label>
      <div class="pg-size-select-wrap">
        <select
          [id]="sizeId"
          class="pg-size-select"
          [value]="compPageSize"
          (change)="onPageSizeChange($event)"
        >
          @for (opt of pageSizeOptions; track opt) {
          <option [value]="opt">{{ opt }}</option>
          }
        </select>
        <!-- chevron icon -->
        <svg
          class="pg-size-chevron"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9"></polyline>
        </svg>
      </div>
    </div>

    <!-- Divider -->
    <span class="pg-divider" aria-hidden="true"></span>

    <!-- Showing info -->
    @if (totalItems) {
    <span class="pg-info">
      Showing
      <span class="pg-info-bold">{{ showingFrom | number }}</span>
      &ndash;
      <span class="pg-info-bold">{{ showingTo | number }}</span>
      of
      <span class="pg-info-bold">{{ totalItems | number }}</span>
    </span>
    } @else {
    <span class="pg-info">
      Page
      <span class="pg-info-bold">{{ compCurrentPage + 1 }}</span>
      of
      <span class="pg-info-bold">{{ compTotalPage || 1 }}</span>
    </span>
    }
  </div>

  <!-- Middle: go to page -->
  <div class="pg-goto">
    <label class="pg-goto-label" [for]="gotoId">Go to</label>
    <input
      #pageInput
      [id]="gotoId"
      type="number"
      class="pg-goto-input"
      min="1"
      [max]="compTotalPage"
      placeholder="{{ compTotalPage }}"
      (keydown.enter)="goToPageDirect(pageInput)"
    />
    <button type="button" class="pg-goto-btn" (click)="goToPageDirect(pageInput)" title="Go to page" aria-label="Go to page">
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>

  <!-- Right: nav controls -->
  <div class="pg-controls">
    @if (loading) {
    <app-loading-spinner className="pg-spinner" />
    }

    <!-- First page -->
    <button
      type="button"
      class="pg-btn pg-btn-edge pg-btn-jump"
      [class.pg-btn-disabled]="compCurrentPage <= 0"
      [disabled]="compCurrentPage <= 0"
      (click)="goToFirst()"
      title="First page"
      aria-label="First page"
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="11 17 6 12 11 7"></polyline>
        <polyline points="18 17 13 12 18 7"></polyline>
      </svg>
    </button>

    <!-- Previous -->
    <button
      type="button"
      class="pg-btn pg-btn-edge"
      [class.pg-btn-disabled]="compCurrentPage <= 0"
      [disabled]="compCurrentPage <= 0"
      (click)="prev()"
      title="Previous page"
      aria-label="Previous page"
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>

    <!-- Page numbers -->
    @for (page of pageNumbers; track $index) {
      @if (page === '...') {
        <span class="pg-ellipsis" aria-hidden="true">&hellip;</span>
      } @else {
        <button
          type="button"
          class="pg-btn pg-btn-num"
          [class.pg-btn-active]="page === compCurrentPage"
          [attr.aria-current]="page === compCurrentPage ? 'page' : null"
          [attr.aria-label]="'Page ' + (+page + 1)"
          (click)="goToPage(+page)"
        >{{ +page + 1 }}</button>
      }
    }

    <!-- Next -->
    <button
      type="button"
      class="pg-btn pg-btn-edge"
      [class.pg-btn-disabled]="compCurrentPage >= compTotalPage - 1"
      [disabled]="compCurrentPage >= compTotalPage - 1"
      (click)="next()"
      title="Next page"
      aria-label="Next page"
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>

    <!-- Last page -->
    <button
      type="button"
      class="pg-btn pg-btn-edge pg-btn-jump"
      [class.pg-btn-disabled]="compCurrentPage >= compTotalPage - 1"
      [disabled]="compCurrentPage >= compTotalPage - 1"
      (click)="goToLast()"
      title="Last page"
      aria-label="Last page"
    >
      <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="13 17 18 12 13 7"></polyline>
        <polyline points="6 17 11 12 6 7"></polyline>
      </svg>
    </button>
  </div>

</nav>
